import { AsyncReturnType } from "type-fest";

import { BillingService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof BillingService.updatePaymentMethod>[0];
type Data = AsyncReturnType<typeof BillingService.updatePaymentMethod>;
type Error = unknown;

export const useUpdatePaymentMethod = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    BillingService.updatePaymentMethod,
    options
  );

  return result;
};
